import React, { useEffect, useState } from 'react'
import MainNav from '../../Components/Navbar'
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col'
import { Container } from 'react-bootstrap';
import { getDatabase, ref, get, child, set, update } from "firebase/database";



export default function Configuracoes() {

    const [globalCompanyOnline, setGlobalCompanyOnline] = useState(false)
    const [globalRollTimeLimitOnline, setGlobalRollTimeLimitOnline] = useState(0)
    const [globalRollTimeLimitOffline, setGlobalRollTimeLimitOffline] = useState(0)

    const db = getDatabase()

    useEffect(() => {
        const path = `/globalSettings`

        get(child(ref(db), path)).then((snapshot) => {
            if (snapshot.exists()) {
                const globalSettings = snapshot.val()

                if (Object.keys(globalSettings).includes("isDeptOnline")) {
                    setGlobalCompanyOnline(globalSettings.isDeptOnline)
                }

                if (Object.keys(globalSettings).includes("rollTimeLimit")) {
                    if (Object.keys(globalSettings["rollTimeLimit"]).includes("online")) {
                        setGlobalRollTimeLimitOnline(globalSettings["rollTimeLimit"]["online"])
                    }
                    if (Object.keys(globalSettings["rollTimeLimit"]).includes("offline")) {
                        setGlobalRollTimeLimitOffline(globalSettings["rollTimeLimit"]["offline"])
                    }
                }
            }
        })
    }, [])

    const updateGlobalOnlineRollTimeLimit = async (e) => {
        const value = e.target.value;

        setGlobalRollTimeLimitOnline(value);

        const path = `/globalSettings/rollTimeLimit`

        await update(ref(db, path), { "online": value })
    }

    const updateGlobalOfflineRollTimeLimit = async (e) => {
        const value = e.target.value;

        setGlobalRollTimeLimitOffline(value);

        const path = `/globalSettings/rollTimeLimit`

        await update(ref(db, path), { "offline": value })
    }

    const updateGlobalCompanyOnline = async (e) => {
        const checked = e.target.checked;

        setGlobalCompanyOnline(checked)

        const path = `/globalSettings/`

        await update(ref(db, path), { "isDeptOnline": checked })
    }

    return <>
        <MainNav />

        <>
            <Container className='mt-3'>
                <Row>
                    <Col md={4}>
                        <h5>Configurações de Notificação Padrão</h5>
                        <i><p>Essas configurações serão utilizadas para todas as empresas onde as mesmas não forem alteradas.</p></i>
                        <p><b>Atenção:</b> As alterações serão aplicadas <u><b>imediatamente</b></u></p>

                        <Form>
                            <Form.Group className='mb-3'>
                                <Form.Label className='fw-semibold'>Notificações</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    label={globalCompanyOnline ? "Empresas Online" : "Empresas Offline"}
                                    checked={globalCompanyOnline}
                                    onChange={(e) => updateGlobalCompanyOnline(e)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-1">
                                <Form.Label className='fw-semibold'>Tempo máximo para lançamento de presença</Form.Label>

                                <div className='d-flex align-items-center'>
                                    <div className='me-2 fw-semibold'>Online</div>
                                    <Form.Select style={{ "maxWidth": "160px" }} onChange={(e) => updateGlobalOnlineRollTimeLimit(e, true)} value={globalRollTimeLimitOnline}>
                                        <option value="0">Sem limite</option>
                                        <option value="10">10 minutos</option>
                                        <option value="30">30 minutos</option>
                                        <option value="60">1 hora</option>
                                        <option value="180">3 horas</option>
                                        <option value="360">6 horas</option>
                                        <option value="720">12 horas</option>
                                    </Form.Select>
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <div className='d-flex align-items-center'>
                                    <div className='me-2 fw-semibold'>Offline</div>
                                    <Form.Select style={{ "maxWidth": "160px" }} onChange={(e) => updateGlobalOfflineRollTimeLimit(e, false)} value={globalRollTimeLimitOffline}>
                                        <option value="0">Sem limite</option>
                                        <option value="10">10 minutos</option>
                                        <option value="30">30 minutos</option>
                                        <option value="60">1 hora</option>
                                        <option value="180">3 horas</option>
                                        <option value="360">6 horas</option>
                                        <option value="720">12 horas</option>
                                    </Form.Select>
                                </div>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
            </Container>

        </>

    </>
}
